export default "__VITE_ASSET__eeqlcmjB__"